export default __webpack_public_path__ + "static/media/photo03.0dffa8b9.jpg";